// extracted by mini-css-extract-plugin
module.exports = {"search-input":"SearchInput_search-input__2f-Vd","delete-container":"SearchInput_delete-container__2HfaL","delete-icon":"SearchInput_delete-icon__3CKA7"};